import { BUSINESS } from "@/data/legal";

const Sec = ({ n, title, children }) => (
  <section>
    <h2 className="font-display text-bone text-3xl">
      <span className="text-brass mr-3">{n}.</span>{title}
    </h2>
    <div className="mt-4 space-y-3">{children}</div>
  </section>
);

export default function Terms() {
  return (
    <div data-testid="terms-page" className="pt-28 md:pt-36 pb-24 md:pb-32">
      <section className="mx-auto max-w-3xl px-6 md:px-10">
        <p className="label-eyebrow">Legal</p>
        <h1 className="font-display text-bone text-5xl md:text-6xl mt-5 leading-[0.95]">Terms of Service</h1>
        <p className="mt-6 text-bone/60 text-sm">Last updated: {new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</p>

        <div className="mt-12 space-y-10 text-bone/75 leading-relaxed">
          <p>
            These Terms of Service (the &ldquo;Terms&rdquo;) govern your access to and use of the website, products,
            stewardships, events, and services offered by <span className="text-bone">{BUSINESS.legalName}</span>{" "}
            (&ldquo;the Company,&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;). By using this site you agree to these Terms.
          </p>

          <Sec n="1" title="Website Use">
            <p>You agree to use the site lawfully and not to interfere with its operation, attempt to gain unauthorized access, or scrape, copy, or republish content without permission. We may modify or discontinue any part of the site at any time without notice.</p>
          </Sec>

          <Sec n="2" title="Stewardship Program">
            <p>The Founding House Steward program assigns each Steward a permanent Steward Number issued in the order received. Stewardship confers benefits such as early access to limited drops, secret menu access, and event invitations. Benefits, availability, and pricing of any paid tier may be modified at our discretion. Stewardships are personal, non-transferable, and may be revoked for misuse or violation of these Terms.</p>
          </Sec>

          <Sec n="3" title="SMS Communications (House Alerts)">
            <p>When you opt in to House Alerts you authorize us to send recurring automated promotional and personalized marketing text messages from {BUSINESS.legalName} regarding Weekly Drops, Menu Releases, Event Announcements, Order Updates, Stewardship Updates, and Promotional Offers.</p>
            <p>Consent is not a condition of purchase. Message frequency varies. Message and data rates may apply. Reply <span className="text-brass">STOP</span> to unsubscribe and <span className="text-brass">HELP</span> for assistance. Full disclosures are available on the House Alerts and Privacy Policy pages.</p>
          </Sec>

          <Sec n="4" title="Event Participation">
            <p>Tickets, reservations, and seats for pop-ups and events are limited and may be subject to additional terms displayed at the time of reservation. You agree to follow venue rules and reasonable instructions from staff. We may refuse service or remove guests who endanger others, our team, or our property. Force majeure events (severe weather, civil unrest, venue closure) may cause changes or cancellation; in those cases we will make reasonable efforts to reschedule or refund.</p>
          </Sec>

          <Sec n="5" title="Ordering Policies">
            <p>All orders are subject to availability. Limited drops are sold first-come, first-served and may sell out. Prices are listed in U.S. dollars and may change without notice. Allergens and ingredients are listed where possible; please review carefully before ordering. We are not liable for allergic reactions when guests fail to disclose allergies. Refunds for prepared food and beverages are at our sole discretion.</p>
          </Sec>

          <Sec n="6" title="Intellectual Property">
            <p>All trademarks, logos, brand names (including &ldquo;The Uncanny House,&rdquo; &ldquo;Pumabilt,&rdquo; &ldquo;House Alerts,&rdquo; and &ldquo;Crafted for Obsession&rdquo;), photography, recipes, menus, copy, and design elements on this site are the property of {BUSINESS.legalName} or its licensors and are protected by U.S. and international intellectual property laws. You may not reproduce, distribute, or create derivative works without our prior written consent.</p>
          </Sec>

          <Sec n="7" title="Disclaimers &amp; Limitation of Liability">
            <p>The site is provided &ldquo;as is&rdquo; without warranties of any kind. To the fullest extent permitted by law, {BUSINESS.legalName} is not liable for any indirect, incidental, special, or consequential damages arising from your use of the site or services.</p>
          </Sec>

          <Sec n="8" title="Changes to These Terms">
            <p>We may update these Terms from time to time. The updated version will be posted on this page with a new effective date. Continued use of the site after changes constitutes acceptance.</p>
          </Sec>

          <Sec n="9" title="Contact">
            <p>Questions about these Terms? Write to <a className="text-brass hover:text-champagne" href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a>.</p>
          </Sec>
        </div>
      </section>
    </div>
  );
}
